import {withAppContext} from "../../util/withAppContext";
import withNavigate from "../../util/useNavigate";
import withBreakpoint from "../../util/withBreakpoint";

import {EnlilTableTree} from "../EnlilTableTree";

class ETLGoogleConfigurationDetailTableView extends EnlilTableTree {

}

export default withNavigate(withAppContext(withBreakpoint(ETLGoogleConfigurationDetailTableView)));